import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import DailyView from '../views/DailyView';
import WeeklyView from '../views/WeeklyView';
import GridView from '../views/GridView';
import CrewLeaderView from '../views/CrewLeaderView';
import MonthlyView from '../views/MonthlyView';
import classnames from 'classnames';
import { SCHEDULE_DAY_VIEWS, SCHEDULE_VIEW_TYPES } from 'pages/ScheduleV6/constants/constants';

/**
 * High-level calendar layout.
 *
 * Responsibilities:
 * - decide which view component to render based on `view`
 * - provide a single wrapper for calendar sizing/styles
 *
 * It must NOT contain FullCalendar config or business logic.
 */
const CalendarLayout = ({
  calendarRef,
  selectedDate,
  scheduleDayView,
  scheduleView,
  filters,
  navigate,
  dateFormat,
  timeFormat,
  isResourcesOpen,
  showNoClSheets,
  noClSheets,
  hasEditAccess = false,
}) => {
  const ActiveViewComponent = useMemo(() => {
    switch (scheduleView) {
      case SCHEDULE_VIEW_TYPES.weekly:
        return WeeklyView;
      case SCHEDULE_VIEW_TYPES.monthly:
        return MonthlyView;
      default:
        switch (scheduleDayView) {
          case SCHEDULE_DAY_VIEWS.grid:
            return GridView;
          case SCHEDULE_DAY_VIEWS.cl:
            return CrewLeaderView;
          default:
            return DailyView;
        }
    }
  }, [scheduleDayView, scheduleView]);

  return (
    <div
      className={classnames(
        'schedule-v6-calendar-wrapper',
        !isResourcesOpen && 'left-expanded',
        scheduleDayView === SCHEDULE_DAY_VIEWS.cl && 'cl-view'
      )}
    >
      <ActiveViewComponent
        calendarRef={calendarRef}
        selectedDate={selectedDate}
        filters={filters}
        navigate={navigate}
        dateFormat={dateFormat}
        timeFormat={timeFormat}
        showNoClSheets={showNoClSheets}
        noClSheets={noClSheets}
        hasEditAccess={hasEditAccess}
      />
    </div>
  );
};

CalendarLayout.propTypes = {
  calendarRef: PropTypes.object,
  selectedDate: PropTypes.instanceOf(Date),
  scheduleDayView: PropTypes.string,
  scheduleView: PropTypes.string,
  filters: PropTypes.object,
  navigate: PropTypes.func,
  dateFormat: PropTypes.string,
  timeFormat: PropTypes.string,
  isResourcesOpen: PropTypes.bool,
  showNoClSheets: PropTypes.bool,
  noClSheets: PropTypes.arrayOf(PropTypes.string),
  hasEditAccess: PropTypes.bool,
};

export default CalendarLayout;

